import React from "react";
import Image from "../../assets/Images/about-bg.jpg";

export default function About() {
  return (
    <div className="page">
      <div className="row no-gutters row-layout">
        <div
          className="col-lg-7 col-layout"
          style={{ backgroundImage: `url(${Image})` }}
        >
          {/* <img src={Image} alt="Store front" className="col-image" /> */}
        </div>
        <div className="col-lg-5 col-layout2">
          <div className="column-info2">
            <h2>Who We Are.</h2>
            <p>
              Black Jade Tattoo was created in 2020 housing highly skilled
              artists providing a diverse range of styles that the modern tattoo
              world has to offer.
            </p>
            <p>
              We offer many creative styles that are unique to each artist,
              creating custom tattoos tailored to the individual. Our focus is
              to deliver polished artistic results with top-quality service. We
              take pride in our professionalism and creating a fun and friendly
              tattooing experience.
            </p>
            <p>
              Our studio is a safe, clean, and inclusive space where clients are
              encouraged to work with their chosen artist on their tattoo
              design. Contact us and discuss your ideas, and you'll be guided to
              an artist whose skills would best match your needs to make your
              tattoo dreams a reality.
            </p>
          </div>
          <div className="column-info2 bg_black">
            <h2>Work Opportunities.</h2>
            <p>
              We are seeking permanent and guest artists who specialize in many
              different styles to fulfill our clients' needs. Black Jade Tattoo
              offers a clean and creative environment, the shop is well-managed
              and efficiently coordinated with strong support staff.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
